import React, { useEffect, useState } from "react";
import "./Subscriptions.css";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import SuperAdminTabs from "../../../../Componants/Common/SuperAdminTabs";
import { getSuperAdminSubscribeDashboard,getOrganizations } from "../../../../API Service/apiService";
import  Loader from "../../../../Componants/Loader/Loader";
import activeIcon from "../../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../../Assests/inactiveIcon.svg";
import Paginate from "../../../../Componants/Common/Paginate";
import { formatDate } from "../../../../utils/dateFormatter";
import toast, { Toaster } from "react-hot-toast";


const Subscriptions = () => {
  const [subscribeDashboard,setSubscribeDashboard]=useState([]);
  const [organizations,setOrganizations]=useState([]);
  const [totalRecords,setTotalRecords]=useState(0);
  const [page,setPage]=useState(1);
  const [dataSize,setDataSize]=useState(10);
  const [isLoading,setIsLoading]=useState(false)
  useEffect(()=>{
    fetchSubscribeDashboard();
  },[]);
  useEffect(()=>{
    fetchOrganizations();
  },[page,dataSize]);

  const handlePageChange=(pageNumber)=>{
    setPage(pageNumber);
  }
 
  const fetchSubscribeDashboard=async()=>{
    try{
      const response=await getSuperAdminSubscribeDashboard();
      setSubscribeDashboard(response);
    }catch(error){
      console.error("Error fetching super admin subscribe dashboard:", error);
      // throw error;
      toast.error("Error fetching super admin subscribe dashboard.");
      setIsLoading(false);
    }
  }
  
  const fetchOrganizations=async()=>{
    setIsLoading(true);
    try{
      setIsLoading(true);
      let body={
        page:page,
        size:dataSize
      }
      const response=await getOrganizations(body);
      console.log(response.data.organizations );
      setOrganizations(response.data.organizations);
      setTotalRecords(response.data.pagination.totalRecords);
      // setTotalPages(data.data.pagination.totalPages)
    }catch(error){
      console.error("Error fetching organizations:", error);
      setIsLoading(false);
    }finally{
      setIsLoading(false);
    }
  }
  
  return (
    <> {isLoading && <Loader/>}
      <HeaderNavigation value={"Subscriptions"} />
      <SuperAdminTabs />
      <div className="container-Subscriptions">
        <div className="Dashboard-Subscriptions">
          <div className="databox-Subscriptions">
            <div className="boxone-Subscriptions">
              {" "}
              <div className="firsttext--Subscriptions">Total Clients</div>
              <div className="firsttext--Subscriptions">
                <div className="valuewithimg-Subscriptions">
                  <div>{subscribeDashboard.totalSubscribers}</div>
                </div>
              </div>
            </div>
            <div className="boxone-Subscriptions">
              {" "}
              <div className="firsttext--Subscriptions">Active Clients</div>
              <div className="firsttext--Subscriptions">
                {subscribeDashboard.activeSubscribers}
              </div>
            </div>
            <div className="boxone-Subscriptions">
              {" "}
              <div className="firsttext--Subscriptions">Stopped Clients</div>
              <div className="firsttext--Subscriptions">
                {subscribeDashboard.stoppedSubscribers}
              </div>
            </div>
          </div>

          <div className="chart-Subscriptions"></div>
          <div className="table-Subscriptions">
            <table>
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Company Name</th>
                  <th>Client Name</th>
                  <th>Subscription Plan</th>
                  <th>Subscribed On</th>
                  <th>Total Licenses</th>
                  <th>left Licenses</th>
                  <th>Payment Due Date</th>
                  <th>Status</th>
                  <th>Info</th>
                </tr>
              </thead>
              <tbody>
                {organizations.map((organization,index)=>(
                <tr key={index}>
                  <td>{(index+1)+(page-1)*dataSize}</td>
                  <td>{organization.companyName}</td>
                  <td>{organization.clientName}</td>
                  <td>{organization.subscriptionPlan || "NA"}</td>
                  <td>{formatDate(organization.subscriptionStartDate)}</td>
                  <td>{organization.licenseKeys[0].noOfLicense}</td>
                  <td>{organization.licenseKeys[0].leftLicence}</td>
                  <td>{formatDate(organization.paymentDueDate)}</td>
                  <td>{organization.subscriptionStatus===true ? <img src={activeIcon} alt="active" /> : <img src={inactiveIcon} alt="inactive" />}</td>
                    {/* <td>
                      <img src="photos\Group 361036.png" alt="Description" />
                    </td>
                    <td>
                      <img src="photos\info.png" alt="Description" />
                    </td> */}

                </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pagination-container">
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
            // onDataSizeChange={handleDataSizeChange}
          />
        </div>
      </div>
    </>
  );
};

export default Subscriptions;
